import { listenerMiddleware } from '../../../../store/middleware';
import { setSelectedMic, setSelectedSpeaker, setSelectedCamera } from '../../../MediaControls/store/mediaControlSlice';
import { setSettingsMic, setSettingsSpeaker, setSettingsCamera } from './settingsSlice';




// These listners mimic the behaviour of the media control slice
// To ensure automatic device listener actions are enforced 
listenerMiddleware.startListening({
    actionCreator: setSelectedMic,
    effect: async (action, listenerApi) => {
        listenerApi.dispatch(setSettingsMic(action.payload));
    }
})

listenerMiddleware.startListening({
    actionCreator: setSelectedSpeaker,
    effect: async (action, listenerApi) => {
        listenerApi.dispatch(setSettingsSpeaker(action.payload));
    }
})

listenerMiddleware.startListening({
    actionCreator: setSelectedCamera,
    effect: async (action, listenerApi) => {
        listenerApi.dispatch(setSettingsCamera(action.payload));
    }
})